/**
 * Client entry point
 */

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'allsettled-polyfill';

import React from 'react';
import { render } from 'react-dom';
import ReactDOMClient, { createRoot } from 'react-dom/client';
import io from 'socket.io-client';

import App from './App';
import { configureStore } from './store';
import { initSocket } from './modules/App/AppActions';
import socketListener from './socketListener';

import config from './config';
import '../Intl/setup';

// PWA Offline support via Workbox service worker
if(process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js');

        // Retire the legacy offline-plugin worker (/sw.js). It used a cache-first strategy over a
        // precache list frozen at build time, so a browser that still has it installed keeps being
        // served the assets of an old release. It lives under a different scope than the Workbox
        // worker above, so both stay registered side by side until this removes it.
        navigator.serviceWorker.getRegistrations().then(registrations => {
            registrations
                .filter(registration => /\/sw\.js$/.test(registration.active?.scriptURL || ''))
                .forEach(registration => {
                    console.log('ServiceWorker::: Unregister legacy worker', registration.active.scriptURL);
                    registration.unregister();
                });
        }).catch(err => console.error('ServiceWorker::: Cannot list registrations', err));
    });
}


const socket = io('', {
    transports: ['websocket', 'polling'],
    credentials: true,
});
// console.log('Socket::: Create', socket);

// Initialize store
const store = configureStore(window.__INITIAL_STATE__);
const container = document.getElementById('root');

// Patch to prevent blank page on removeChild: Use with caution, performance leaks
// if (typeof Node === 'function' && Node.prototype) {
//   const originalRemoveChild = Node.prototype.removeChild;
//   Node.prototype.removeChild = function(child) {
//     if (child.parentNode !== this) {
//       if (console) {
//         console.error('Cannot remove a child from a different parent', child, this);
//       }
//       return child;
//     }
//     return originalRemoveChild.apply(this, arguments);
//   }
// }
store.dispatch(initSocket(socket));
socketListener(socket, store.dispatch, store.intl);

ReactDOMClient.hydrateRoot(container, <App store={store} />);

// For hot reloading of react components
if(module.hot) {
    module.hot.accept('./App', () => {
        const NextApp = require('./App').default; // eslint-disable-line global-require
        ReactDOMClient.hydrateRoot(container, <NextApp store={store} />);
    });
}
